import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';
import { translate } from 'react-i18next';
import { Search, Role, Locked, RegistrationStatus } from '../../account-management/components/filters';
import { AccountsTable } from './';
import { CallCentrumLanding } from './'

@translate()
export default class CallCentrumScreen extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    accounts: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    onTableChange: PropTypes.func.isRequired,
    onFilterSearchChange: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    token: PropTypes.string.isRequired,
  };

  render() {
    const {
      accounts,
      pagination,
      filter,
      onTableChange,
      onFilterStatusChange,
      onFilterRoleChange,
      onFilterLockedChange,
      onFilterSearchChange,
      isLoading,
      token,
      t,
    } = this.props;

    let filteredAccounts = accounts.filter(acc => acc.role === 'DEBTOR' || acc.role === 'CREDITOR')
    return (

      <section style={{margin: 50+'px'}}>
        <h1>{t('Klienti')}</h1>

        <Row center="xs" className="filters padded">
          <Col xs={12} sm={4}>
            <Search
              key="accountSearch"
              defaultValue={filter.search}
              onSearch={onFilterSearchChange}
            />
          </Col>
        </Row>

        <AccountsTable
          accounts={filteredAccounts}
          pagination={pagination}
          onChange={onTableChange}
          loading={isLoading}
        />

        
      </section>
    );
  }
}


// WEBPACK FOOTER //
// ./src/features/call-centrum/components/CallCentrumScreen.js